/* size-translator.js — universal "Find your size" module.
   All sizes, maps and rules come from the block settings (inline JSON island). */
(function () {
  if (window.__sztBound) return;
  window.__sztBound = true;

  function parseMap(str) {
    var m = {};
    (str || '').split(',').forEach(function (pair) {
      var p = pair.split(':');
      if (p.length === 2) m[p[0].trim()] = p[1].trim();
    });
    return m;
  }
  function parseList(str) {
    return (str || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function resolve(value, rule, downMap, alphaMap) {
    switch (rule) {
      case 'down':       return downMap[value] || value;
      case 'alpha':      return alphaMap[value] || value;
      case 'alpha_down': {
        var a = alphaMap[value] || value;
        return downMap[a] || a;
      }
      case 'up': {
        // reverse the down map
        for (var k in downMap) { if (downMap[k] === value) return k; }
        return value;
      }
      default:           return value;   // 'same'
    }
  }

  function initSheet(sheet) {
    if (sheet.dataset.sztReady) return;
    sheet.dataset.sztReady = '1';

    var dataEl = sheet.querySelector('[data-szt-data]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var downMap  = parseMap(D.downMap);
    var alphaMap = parseMap(D.alphaMap);
    var lists = { top: parseList(D.topSizes), bot: parseList(D.botSizes) };
    var rows  = { top: D.topRows || [],       bot: D.botRows || [] };

    ['top', 'bot'].forEach(function (key) {
      var chipWrap = sheet.querySelector('[data-szt-chips="' + key + '"]');
      var resWrap  = sheet.querySelector('[data-szt-res="' + key + '"]');
      var rowWrap  = sheet.querySelector('[data-szt-rows="' + key + '"]');
      if (!chipWrap || !lists[key].length) return;

      chipWrap.innerHTML = lists[key].map(function (v) {
        return '<button type="button" class="szt-chip" data-v="' + v + '">' + v + '</button>';
      }).join('');

      chipWrap.querySelectorAll('.szt-chip').forEach(function (btn) {
        btn.addEventListener('click', function () {
          chipWrap.querySelectorAll('.szt-chip').forEach(function (b) { b.classList.remove('on'); });
          btn.classList.add('on');
          var chosen = btn.getAttribute('data-v');

          rowWrap.innerHTML = rows[key].map(function (r) {
            var out = resolve(chosen, r.rule, downMap, alphaMap);
            return '<div class="szt-row"><span>' + r.label + '</span><b>' + out + '</b></div>';
          }).join('');
          if (resWrap) resWrap.hidden = false;
        });
      });
    });
  }

  /* ---- open / close ---- */
  var lastFocus = null;
  function open(sheet) {
    lastFocus = document.activeElement;
    sheet.hidden = false;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var c = sheet.querySelector('[data-szt-close]');
    if (c) c.focus();
  }
  function close(sheet) {
    sheet.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    setTimeout(function () { sheet.hidden = true; }, 230);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-szt-open]');
    if (opener) {
      var sheet = document.getElementById(opener.getAttribute('data-szt-open'));
      if (sheet) { initSheet(sheet); open(sheet); }
      return;
    }
    var closer = e.target.closest('[data-szt-close]');
    if (closer) { close(closer.closest('[data-szt-sheet]')); return; }
    var sh = e.target.closest('[data-szt-sheet]');
    if (sh && !e.target.closest('[data-szt-panel]')) close(sh);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open_ = document.querySelector('[data-szt-sheet].is-open');
    if (open_) close(open_);
  });
})();